import { useNavigate } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { createExhibitor } from "api/exhibitor.api";
import ExhibitorForm from "components/exhibitor/ExhibitorForm";

export default function CreateExhibitor() {
  const navigate = useNavigate();
  const [alert, setAlert] = useState("");

  const handleSubmit = async (fd) => {
    try {
      await createExhibitor(fd);
      navigate("/admin/exhibitors");
    } catch (err) {
      setAlert(err.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <ExhibitorForm
      onSubmit={handleSubmit}
      onBack={() => navigate("/admin/exhibitors")}
      alert={alert}
      setAlert={setAlert}
    />
  );
}
